import * as Communicator from "@ts3d-hoops/web-viewer";
import { GlobalState } from "common/global";
import { Observable, Subject, Subscription } from "rxjs";
import { buffer, debounceTime, filter, switchMap } from "rxjs/operators";
import ModelHelper from "../model/model.helper";
import { selectionFlag } from "./CSelectionManager";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default class CSelectionOperator extends Communicator.Operators
    .SelectionOperator {
    viewer: Communicator.IWebViewer;
    mouseDown$: Subject<Communicator.Event.MouseInputEvent>;
    sub = Subscription.EMPTY;

    constructor(viewer: Communicator.IWebViewer) {
        super(viewer, viewer.view, viewer.noteTextManager);
        this.viewer = viewer;
        this.mouseDown$ = new Subject();
        this.dbClickHandle();
    }

    onDoubleClick() {
        return Promise.resolve();
    }
    onMouseDown(event: Communicator.Event.MouseInputEvent) {
        if (event.getButton() === Communicator.Button.Left) {
            this.mouseDown$.next(event);
        }
        super.onMouseDown(event);
    }

    onMouseUp(event: Communicator.Event.MouseInputEvent) {
        if (GlobalState.selectionEvent && this.isSelectionActive()) {
            const flags = this._viewer.selectionManager.getFlag();
            if (flags.includes(selectionFlag.SelectByTree))
                this._viewer.selectionManager.removeFlag(
                    selectionFlag.SelectByTree
                );
            /** Hieu Pham: The family, category selection item if the part is already selected */
            const pointDistance = Communicator.Point2.subtract(
                this._ptFirst,
                this._ptCurrent
            ).length();
            if (
                pointDistance < 5 &&
                (event.getButton() === Communicator.Button.Left ||
                    this._primaryTouchId !== null)
            ) {
                const { view, model } = this._viewer;

                const config = new Communicator.PickConfig(
                    Communicator.SelectionMask.Face |
                        Communicator.SelectionMask.Line
                );

                const listNodeId = ModelHelper.getNodeIdCuttingPlane(
                    this._viewer
                );
                listNodeId.length > 0 &&
                    model.setInstanceModifier(
                        Communicator.InstanceModifier.DoNotSelect,
                        listNodeId,
                        true
                    );
                // view.pickAllFromPoint(this._ptCurrent, config).then(s => {
                //     const map = s.map(v => {
                //         const p = v.getPosition();
                //         const id = v.getNodeId();
                //         const pt = view.projectPoint(p);

                //         return { id, x: p.x, y: p.y, z: p.z, x1: pt.x, y1: pt.y, z1: pt.z }
                //     })
                //     // array sort => smaller id
                //     console.log(
                //         map
                //             .sort((a, b) => {
                //                 const z1 = a.z1 - b.z1;
                //                 if (z1 === 0) {
                //                     return a.id - b.id;
                //                 } else {
                //                     return z1;
                //                 }
                //             })
                //     )
                // })
                // best candidate =>result[0]
                const p = view
                    .pickFromPoint(this._ptCurrent, config)
                    .then((selection) => {
                        const { cuttingManager, noteTextManager } =
                            this._viewer;
                        const cuttingSelected =
                            cuttingManager.getCuttingSectionFromNodeId(
                                selection.getNodeId()
                            ) !== null;
                        const notePinSelected =
                            noteTextManager.selectPin(selection);

                        const pickedMarkup =
                            this._viewer.markupManager.pickMarkupItem(
                                this._ptCurrent,
                                this._viewer.view
                            );
                        if (
                            pickedMarkup instanceof
                            Communicator.Operators.Markup.Redline.RedlineText
                        ) {
                            pickedMarkup.onSelect(view);
                        }

                        if (
                            !notePinSelected &&
                            !cuttingSelected &&
                            pickedMarkup === null
                        ) {
                            if (selection.isNodeSelection()) {
                                this._handleSelectionClick(event, selection);
                            } else if (!this._isDoubleClick) {
                                this._viewer.selectionManager.clear();
                            }
                        }

                        listNodeId.length > 0 &&
                            this.viewer.model.setInstanceModifier(
                                Communicator.InstanceModifier.DoNotSelect,
                                listNodeId,
                                false
                            );
                    });

                void p;
            }
        }
        super.onMouseUp(event);
    }

    private _handleSelectionClick(
        event: Communicator.Event.MouseInputEvent,
        selection: Communicator.Selection.NodeSelectionItem
    ): void {
        // don't add overlay geometry into the selection set
        const overlayIndex = selection.overlayIndex();
        if (overlayIndex !== 0 && overlayIndex !== null) {
            return;
        }

        const { selectionManager } = this._viewer;

        if (event.controlDown() || event.commandDown()) {
            selectionManager.toggle(selection);
        } else {
            GlobalState.nodeSelectionItem$.next(selection);
        }
    }

    public isActive(): boolean {
        // disable method select item of hoops
        return false;
    }

    public isSelectionActive(): boolean {
        return (
            (this._buttonModifierActive || this._primaryTouchId !== null) &&
            !this._isDoubleClick &&
            !this._viewer.getContextMenuStatus()
        );
    }

    public onMouseMove(event: Communicator.Event.MouseInputEvent): void {
        if (this.isSelectionActive()) {
            this._ptPrevious.assign(this._ptCurrent);
            this._ptCurrent.assign(event.getPosition());
            if (this._dragging) {
                if (!this._ptCurrent.equals(this._ptPrevious)) {
                    ++this._dragCount;

                    if (this._dragCount === 1) {
                        this._viewer.trigger("beginInteraction");
                    }
                }
            }
        }
    }

    private dbClickHandle() {
        this.sub = this.mouseDown$
            .pipe(
                buffer(this.mouseDown$.pipe(debounceTime(250))),
                filter((arr) => arr.length === 2),
                switchMap((_) => this.focusSelection())
            )
            .subscribe();
    }
    private focusSelection() {
        return new Observable<void>((subscriber) => {
            const arrSelected = ModelHelper.getSelectionItemId(this.viewer);
            if (
                arrSelected.length > 0 &&
                GlobalState.markupMode === "viewMode"
            ) {
                ModelHelper.getBoundingBox(this.viewer, arrSelected)
                    .then((box) => {
                        box && this.viewer.view.fitBounding(box);
                        subscriber.complete();
                    })
                    .catch((err) => subscriber.complete());
            } else {
                subscriber.complete();
            }
        });
    }
}
